export class WishlistItemCard extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  static get requiredElements () {
    return ['media']
  }

  connectedCallback () {
    super.connectedCallback()

    this.touchX = null
    this.touchY = null
    this.previousSwipeDirection = null
    this.currentSwipeDirection = null
    this.currentIndex = 0

    this.register()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'touchstart', this.handleTouchStart.bind(this))
    this.listeners.add(this, 'touchmove', this.handleTouchMove.bind(this))
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.unregister()
  }

  register () {
    this.tastemakersManager?.register(this)
  }

  unregister () {
    this.tastemakersManager?.unregister(this)
  }

  // Rearrange mode drags the card under the same touches (#446); the
  // image swipe must not fire, or the card comes out of the mode stuck on
  // its secondary image.
  rearranging () {
    return this.closest('[data-rearranging]') !== null
  }

  handleTouchStart (event) {
    if (this.rearranging()) return

    this.touchX = event.touches?.[0]?.clientX
    this.touchY = event.touches?.[0]?.clientY
    this.els?.media?.element?.setAttribute('data-touched', 'true')
  }

  // A vertical scroll drifts a pixel or two sideways per touchmove, and
  // without a vertical band and a minimum travel that drift read as a swipe,
  // flipping the card's gallery while the finger only moved down (#465).
  // The band and the 30px travel are product-card.js's, copied verbatim so
  // both cards answer a thumb the same way. This card was forked from that
  // one on 23.09.2022 (112caf509), three days before those guards were added
  // to it (3af34bf9f), which is how it came to be missing them.
  // product-card.js has a third guard not copied here: swipeIsInsideMediaContainer,
  // which ignores a swipe starting below the image. Out of scope for #465.
  handleTouchMove (event) {
    if (this.rearranging()) return

    const clientX = event.touches?.[0]?.clientX
    const clientY = event.touches?.[0]?.clientY

    if (!this.isInRange(clientY, this.touchY - 15, this.touchY + 15)) return

    this.previousSwipeDirection = this.currentSwipeDirection

    if (this.touchX && this.touchX !== clientX) {
      // Left swipe
      if (clientX < this.touchX - 30) {
        this.currentSwipeDirection = 'left'
      }

      // Right swipe
      if (clientX > this.touchX + 30) {
        this.currentSwipeDirection = 'right'
      }
    }

    if (this.currentSwipeDirection !== this.previousSwipeDirection) {
      this.updateIndex()
      this.touchX = clientX
      this.touchY = clientY
    }
  }

  updateIndex () {
    if (this.currentSwipeDirection === 'left') {
      this.currentIndex = 1
    } else {
      this.currentIndex = 0
    }
  }

  isInRange (value, first, last) {
    const lower = Math.min(first, last)
    const upper = Math.max(first, last)

    return value >= lower && value <= upper
  }

  set currentIndex (index) {
    this._currentIndex = index
    this.els?.media?.element?.setAttribute('data-index', String(index))
  }

  get currentIndex () {
    return this._currentIndex
  }

  get tastemakersManager () {
    return window.BAO?.Tastemakers?.manager
  }
}

if (!customElements.get('wishlist-item-card')) {
  customElements.define('wishlist-item-card', WishlistItemCard, {
    extends: 'article',
  })
}
